import { unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "flex items-center gap-3 overflow-x-auto py-2",
  "data-cy": "bulk-action-toolbar"
};
const _hoisted_2 = {
  class: "flex items-center gap-2 flex-shrink-0"
};
const _hoisted_3 = {
  key: 0,
  class: "text-xs text-gray-500 whitespace-nowrap flex items-center gap-1",
  "data-cy": "bulk-action-helper-text"
};
const _hoisted_4 = {
  class: "flex items-center gap-3 flex-shrink-0"
};
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useMeStore } from '@/services/UserService/useMeStore';
import isEntryBilled from '@/utils/entryUtils';
import { pluralizeEntryWithCount } from '@/services/utils';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
export default {
  __name: 'BulkActionToolbar',
  props: {
    selectedEntries: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['assign-to-fixed-fee', 'change-matter', 'mark-billable', 'mark-non-billable', 'clear-selection'],
  setup(__props) {
    const props = __props;

    // Store
    const {
      terms
    } = storeToRefs(useMeStore());

    // Computed — terminology
    const matterTerm = computed(() => terms.value?.Matter || 'Matter');

    // Computed — selection count
    const selectedCount = computed(() => props.selectedEntries.length);

    // Computed — eligibility checks (mirrors FixedFeeTimeEntriesTab pattern)
    const areAllFixedFee = computed(() => selectedCount.value > 0 && props.selectedEntries.every(e => e.billingType === 'fixedFee'));
    const areSameMatter = computed(() => selectedCount.value > 0 && props.selectedEntries.every(e => e.matter_id === props.selectedEntries[0]?.matter_id));
    const noneAreBilled = computed(() => selectedCount.value > 0 && props.selectedEntries.every(e => !isEntryBilled(e)));

    // Computed — bulk action disabled (matches FixedFeeTimeEntriesTab pattern)
    const isBulkActionDisabled = computed(() => selectedCount.value === 0 || !areAllFixedFee.value || props.disabled);

    // Computed — button states
    const canChangeMatter = computed(() => !isBulkActionDisabled.value);
    const canConvert = computed(() => !isBulkActionDisabled.value && noneAreBilled.value);
    const canAssignToFixedFee = computed(() => selectedCount.value > 0 && !props.disabled && areAllFixedFee.value && areSameMatter.value && noneAreBilled.value);

    // Computed — helper text for disabled actions
    const helperText = computed(() => {
      if (props.disabled) return 'A bulk operation is in progress';
      if (selectedCount.value === 0) return '';
      if (!areAllFixedFee.value) return 'Select only fixed fee entries for bulk actions';
      if (!noneAreBilled.value) return 'Cannot modify billed or invoiced entries';
      if (!areSameMatter.value) return 'Assign to Fee requires entries from the same matter';
      return '';
    });
    return (_ctx, _cache) => {
      const _component_v_icon = _resolveComponent("v-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_withDirectives(_createElementVNode("span", {
        class: "text-sm px-2 py-0.5 rounded-md border text-green-600 bg-green-50 border-green-600",
        "data-cy": "selection-count-badge"
      }, _toDisplayString(_unref(pluralizeEntryWithCount)(selectedCount.value)) + " selected ", 513), [[_vShow, selectedCount.value > 0]]), helperText.value ? (_openBlock(), _createElementBlock("span", _hoisted_3, [_createVNode(_component_v_icon, {
        icon: "mdi-alert-circle-outline",
        size: "14",
        color: "orange-darken-2"
      }), _createTextVNode(" " + _toDisplayString(helperText.value), 1)])) : _createCommentVNode("", true)]), _cache[9] || (_cache[9] = _createElementVNode("div", {
        class: "flex-grow"
      }, null, -1)), _createElementVNode("div", _hoisted_4, [_createVNode(LlSecondaryButton, {
        variant: "outlined",
        color: "primary",
        disabled: !canConvert.value,
        "data-cy": "mark-billable-button",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('mark-billable'))
      }, {
        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode(" Make Billable ", -1)]))]),
        _: 1
      }, 8, ["disabled"]), _createVNode(LlSecondaryButton, {
        variant: "outlined",
        color: "orange-darken-1",
        disabled: !canConvert.value,
        "data-cy": "mark-non-billable-button",
        onClick: _cache[1] || (_cache[1] = $event => _ctx.$emit('mark-non-billable'))
      }, {
        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode(" Make Non-Billable ", -1)]))]),
        _: 1
      }, 8, ["disabled"]), _createVNode(LlSecondaryButton, {
        variant: "outlined",
        "prepend-icon": "mdi-swap-horizontal",
        disabled: !canChangeMatter.value,
        "data-cy": "change-matter-button",
        onClick: _cache[2] || (_cache[2] = $event => _ctx.$emit('change-matter'))
      }, {
        default: _withCtx(() => [_createTextVNode(" Change " + _toDisplayString(matterTerm.value), 1)]),
        _: 1
      }, 8, ["disabled"]), _createVNode(LlSecondaryButton, {
        variant: "flat",
        color: "primary",
        disabled: !canAssignToFixedFee.value,
        "data-cy": "assign-to-fee-button",
        onClick: _cache[3] || (_cache[3] = $event => _ctx.$emit('assign-to-fixed-fee'))
      }, {
        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode(" Assign to Fee ", -1)]))]),
        _: 1
      }, 8, ["disabled"]), _createVNode(LlSecondaryButton, {
        variant: "outlined",
        "data-cy": "clear-selection-button",
        disabled: !__props.selectedEntries.length,
        onClick: _cache[4] || (_cache[4] = $event => _ctx.$emit('clear-selection'))
      }, {
        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode(" Clear selection ", -1)]))]),
        _: 1
      }, 8, ["disabled"])])]);
    };
  }
};